import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicGroupsSalesItems({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 120 80"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g clipPath="url(#pic_groups_sales-items_svg__a)">
        <path
          opacity={0.3}
          d="M69.073 32.862C69.3 24.47 54.928 9.481 37.75 18.176c-7.99 4.045-7.212 8.794-13.205 16.035-3.572 4.315-8.756 7.926-10.105 13.661C9.87 67.295 34.787 65.04 47 60.88c12.502-4.259 21.49-6.372 22.073-28.017zm29.603 4.969c-2.702-2.769-6.826-2.145-13.073.19-4.698 1.758-9 3.296-13.12 7.214-2.883 2.741-4.889 5.942-6.191 8.879-1.413 3.18-3.562 6.955-1.32 9.534 3.08 3.542 15.495 3.896 25.152-4.702 10.607-9.446 11.194-18.409 8.552-21.115z"
          fill="#FFC266"
        />
        <path
          d="M68.22 13.044c2.18 5.072-.17 10.95-5.256 13.137-5.081 2.186-10.969-.154-13.152-5.224-2.178-5.068.175-10.952 5.256-13.137 5.085-2.187 10.973.153 13.152 5.224z"
          fill="#FB8F23"
        />
        <path
          opacity={0.92}
          d="M61.605 20.74l.566 1.25-1.151.51-.55-1.218c-1.17.439-2.418.576-3.268.373l.017-1.64c.762.158 1.727.093 2.59-.194l-.843-1.864c-1.413.261-3.028.48-3.749-1.114-.536-1.18-.11-2.588 1.617-3.594l-.56-1.24 1.152-.509.55 1.218c.893-.316 1.835-.464 2.643-.354l.046 1.626a5.283 5.283 0 00-2.022.196l.86 1.895c1.408-.276 2.998-.48 3.71 1.092.523 1.164.105 2.557-1.608 3.568zm-3.382-4.425l-.718-1.583c-.55.405-.642.833-.477 1.203.178.387.618.45 1.195.38zm3.196 1.818c-.175-.392-.606-.454-1.177-.406l.699 1.54c.52-.376.64-.779.478-1.134z"
          fill="#fff"
        />
        <path
          d="M38.5 31l-2.097-9H30"
          stroke="#147EC9"
          strokeWidth={4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.28 53.87l-5.9-23.693h42.383c2.133 0 3.72 1.956 3.275 4.032l-5.03 19.66a3.343 3.343 0 01-3.274 2.633H45.551a3.343 3.343 0 01-3.271-2.632zm28.235-17.572H47.979c-.915 0-1.657.513-1.657 1.145v.459c0 .633.742 1.146 1.657 1.146h22.536c.915 0 1.657-.514 1.657-1.146v-.459c0-.632-.742-1.145-1.657-1.145zm-22.536 6.785h22.536c.915 0 1.657.513 1.657 1.146v.459c0 .632-.742 1.145-1.657 1.145H47.979c-.915 0-1.657-.513-1.657-1.145v-.459c0-.633.742-1.146 1.657-1.146z"
          fill="#147EC9"
        />
        <path
          d="M51.148 59a3.639 3.639 0 00-3.648 3.667 3.653 3.653 0 003.657 3.666 3.668 3.668 0 003.667-3.666A3.67 3.67 0 0051.148 59zm13.782 3.667A3.639 3.639 0 0168.578 59a3.685 3.685 0 013.686 3.667 3.668 3.668 0 01-7.334 0z"
          fill="#147EC9"
        />
        <g filter="url(#pic_groups_sales-items_svg__b)">
          <circle cx={85} cy={61} r={14} fill="#fff" />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.071 55.934l3.657 11.687c.427 1.363 2.34 1.398 2.82.052l1.665-4.687 4.49-.95c1.395-.296 1.611-2.197.32-2.8l-10.905-5.092c-1.172-.547-2.434.557-2.047 1.79zm12.457 9.917a1.673 1.673 0 10-3.346 0 1.673 1.673 0 003.346 0z"
          fill="#FB8F23"
        />
      </g>
      <defs>
        <clipPath id="pic_groups_sales-items_svg__a">
          <path fill="#fff" d="M0 0h120v80H0z" />
        </clipPath>
        <filter
          id="pic_groups_sales-items_svg__b"
          x={63}
          y={41}
          width={44}
          height={44}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={4} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_719_15905" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_719_15905" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

SvgPicGroupsSalesItems.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicGroupsSalesItems.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicGroupsSalesItems svgRef={ref} {...props} />
));
export default ForwardRef;
